// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperAbstract-cls1_b24","cls2":"PaperAbstract-cls2_3Cr PaperAbstract-cls1_b24"};